import { render, staticRenderFns } from "./CaptiveForms.vue?vue&type=template&id=50ec1a08&scoped=true"
import script from "./CaptiveForms.vue?vue&type=script&lang=js"
export * from "./CaptiveForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ec1a08",
  null
  
)

export default component.exports